import fsvLogo from "@/images/achieveos-logo.png";
import fsvLogoDark from "@/images/achieveos-logo-dark.png";
import { ThemeToggle } from "@/components/ThemeToggle";

export const PageHeaderLogo = () => {
  return (
    <header className="border-b" style={{ background: "var(--theme-bg-header)", borderColor: "var(--theme-border)" }}>
      <div className="h-20 flex items-center justify-between px-6" style={{ background: "var(--theme-bg-header)" }}>
        <div className="flex items-center gap-4">
          <img src={fsvLogo} alt="AchieveOS Logo" className="h-[36px] w-[155px] max-w-full object-contain dark:hidden" />
          <img
            src={fsvLogoDark}
            alt="AchieveOS Logo"
            className="h-[36px] w-[155px] max-w-full object-contain hidden dark:block"
          />
        </div>
        <ThemeToggle />
      </div>
    </header>
  );
};
